export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

export const UTC_TIMEZONE = 'UTC';
